import React from 'react'
import SavingImg1 from '../../Images/SavingImg/KramikSaving.jpg'
import SideNav from '../Navigation/SideNav'
import Aos from 'aos'

const KramikSaving = () => {

    Aos.init({
        duration: 1500,
        once: false,
        mirror: false,
        easing: 'ease-in-out-sine'
    })

    return (
        <>

            <div className='main'>
                <div className='left-fixed'></div>
                <div className='d-body'>
                    <div className='d-body-nav' data-aos='fade-right'>
                        <SideNav />
                    </div>
                    <div className='d-body-main' data-aos='fade-right'>
                        <div className='saving-body-top'>
                            <h2>क्रमिक बचत</h2>
                        </div>
                        <div className='saving-body'>
                            <div className='saving-main'>
                                <h3>विशेषताहरू :</h3>
                                <p>
                                    <ul>
                                        <li>हरेक महिनाको मसान्तभित्र बचत गर्नुपर्ने ।</li>
                                        <li>अग्र्रिम बचत बुझाउन पनि सकिने ।</li>
                                        <li>सदस्यले अघिल्लो महिनाको बचत नबुझाई पछिल्लो महिनाको बचत बुझाउन नपाईने ।</li>
                                        <li>बचत फिर्ता गर्दा ऋण चुक्ता नगरेसम्म बचत रकम फिर्ता नपाईने साथै अन्य ऋणीको जमानत बसेको सदस्यले समेत ऋण चुक्ता नभएसम्म बचत फिर्ता नहुने ।</li>
                                        <li>सदस्यको सुविधालाई मध्यनजर गरी समूहले आफ्नो समूहमा बचत संकलन गरी समूहको प्रतिनिधि मार्फत संस्थामा आई जम्मा गर्न सकिने साथै संस्थाको प्रतिनिधि समूहमा गई बचत संकलन गर्न सकिने । </li>
                                        <li>ब्याजलाई संरक्षित पूँजी फिर्ता कोष वितरणमा गणना गरिने । </li>
                                        <li>उत्कृष्ट बचत कर्तालाई पुरस्कार तथा सम्मान प्रदान गरिने ।</li>
                                        <li>यस प्रकारको बचतमा न्युनतम रु.१००।– देखि रु.५००।– सम्म मासिक रुपमा बचत राख्न सकिने ।</li>
                                        <li>यसको समयावधी १ वर्षे, २ वर्षे र ३ वर्षे हुन सक्ने ।</li>
                                    </ul>
                                </p>
                            </div>
                            <div className='savingimg'>
                                <img src={SavingImg1} alt='saving-1' />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='right-fixed'></div>
            </div>
        </>
    )
}

export default KramikSaving